import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=42e636e7&scoped=true"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e636e7",
  null
  
)

export default component.exports